// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.org-container {
  padding: 24px 32px 60px;
  background: #f1f5f9;
  min-height: 100vh;
  margin-left: 250px;
  width: calc(100% - 250px);
  box-sizing: border-box;
}
.org-header {
  text-align: center;
  margin-bottom: 48px;
}
.org-header h2 {
  font-size: 1.7rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #1e293b;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-transform: uppercase;
}
.org-header p {
  color: #64748b;
  margin-top: 6px;
  font-size: 0.9rem;
}
.org-status {
  text-align: center;
  color: #64748b;
  padding: 40px 0;
}
.org-error {
  color: #dc2626;
}
.org-chart-scroll {
  width: 100%;
  overflow-x: auto;
  padding: 20px 0 60px;
  -webkit-overflow-scrolling: touch;
}
.org-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.org-level-label {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: #334155;
  border-radius: 6px;
  padding: 8px 20px;
  margin-bottom: 4px;
  position: relative;
  white-space: nowrap;
  box-shadow: 3px 3px 0 rgba(15, 23, 42, 0.15);
}
.org-chart > div:nth-child(4n + 2) .org-level-label {
  background: #2f8f7d;
}
.org-level-count {
  font-weight: 500;
  color: #cbd5e1;
}
.org-level-label::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -20px;
  transform: translateX(-50%);
  width: 2px;
  height: 20px;
  background: #94a3b8;
}
.manager-level {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
  padding-top: 24px;
  margin-bottom: 8px;
  position: relative;
  max-width: 100%;
}
.manager-level::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: #94a3b8;
}

.manager-level:has(> :only-child)::before {
  display: none;
}

.org-card {
  position: relative;
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 14px 18px;
  min-width: 190px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 3px 3px 0 rgba(15, 23, 42, 0.12);
  transition:
    box-shadow 0.15s ease,
    transform 0.15s ease;
}

.org-card:hover {
  box-shadow: 4px 4px 0 rgba(15, 23, 42, 0.18);
  transform: translate(-1px, -1px);
}

.org-card::before {
  content: "";
  position: absolute;
  top: -24px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 24px;
  background: #94a3b8;
}

.org-card h4 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1e293b;
  text-transform: uppercase;
}

.org-card span {
  font-size: 0.78rem;
  color: #64748b;
}

.org-icon {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  background: #334155;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.ceo-card {
  background: #1e293b;
  border-color: #1e293b;
}

.ceo-card h4,
.ceo-card span {
  color: #fff;
}

.ceo-card .org-icon {
  background: #2f8f7d;
  color: #fff;
}

.manager-card .org-icon {
  background: #334155;
  color: #fff;
}

.vertical-line {
  width: 2px;
  height: 28px;
  background: #94a3b8;
  margin: 0 auto;
}

.vertical-line.small {
  height: 18px;
}

/* Classic pure-CSS org-chart tree: fanning connector lines between levels */
.tree,
.tree ul,
.tree li {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}

.tree {
  display: flex;
  justify-content: center;
  min-width: max-content;
  padding: 20px;
}

.tree li {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 14px 0 14px;
}

.tree li::before,
.tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 2px solid #94a3b8;
  width: 50%;
  height: 24px;
}
.tree li::after {
  right: auto;
  left: 50%;
  border-left: 2px solid #94a3b8;
}

.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}
.tree li:only-child {
  padding-top: 0;
}

.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}
.tree li:last-child::before {
  border-right: 2px solid #94a3b8;
  border-radius: 0 6px 0 0;
}
.tree li:first-child::after {
  border-radius: 6px 0 0 0;
}

.tree ul {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  position: relative;
}
.tree ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 2px solid #94a3b8;
  width: 0;
  height: 24px;
}

.tree-badge {
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  border-radius: 6px;
  padding: 8px 18px;
  white-space: nowrap;
  box-shadow: 3px 3px 0 rgba(15, 23, 42, 0.15);
}
.tree-badge-dept {
  background: #88B6F2;
}
.tree-badge-role {
  background: #334155;
}

.tree .org-card {
  min-width: 180px;
}
.tree-badge-company {
  background: #0f172a;
  font-size: 0.9rem;
  padding: 10px 26px;
}
@media (min-width: 1600px) {
  .org-container {
    padding: 32px 48px 72px;
  }
  .tree .org-card,
  .org-card {
    min-width: 210px;
  }
}
@media (max-width: 1399px) {
  .org-container {
    padding: 22px 24px 50px;
  }
}

/* Tablet landscape — sidebar usually still visible but narrower */
@media (max-width: 1199px) {
  .org-container {
    margin-left: 220px;
    width: calc(100% - 220px);
    padding: 20px 20px 44px;
  }
  .org-header h2 {
    font-size: 1.5rem;
  }
  .tree .org-card,
  .org-card {
    min-width: 170px;
    padding: 12px 14px;
  }
}
@media (max-width: 991px) {
  .org-container {
    margin-left: 0;
    width: 100%;
    padding: 18px 16px 40px;
  }
  .org-header {
    margin-bottom: 32px;
  }
  .org-header h2 {
    font-size: 1.35rem;
    gap: 8px;
  }
  .org-header p {
    font-size: 0.85rem;
  }
  .manager-level {
    gap: 20px;
  }
  .tree li {
    padding: 20px 10px 0 10px;
  }
  .org-card,
  .tree .org-card {
    min-width: 160px;
    padding: 12px 14px;
    gap: 10px;
  }
  .org-icon {
    width: 30px;
    height: 30px;
    font-size: 0.85rem;
  }
  .org-card h4 {
    font-size: 0.82rem;
  }
  .org-card span {
    font-size: 0.72rem;
  }
}
@media (max-width: 767px) {
  .org-container {
    padding: 16px 12px 36px;
  }
  .org-header h2 {
    font-size: 1.2rem;
    flex-wrap: wrap;
  }
  .org-level-label,
  .tree-badge {
    font-size: 0.72rem;
    padding: 7px 14px;
  }
  .tree-badge-company {
    font-size: 0.8rem;
    padding: 8px 18px;
  }
  .tree li {
    padding: 18px 8px 0 8px;
  }
  .manager-level {
    gap: 16px;
    padding-top: 18px;
  }
  .org-card,
  .tree .org-card {
    min-width: 150px;
    padding: 10px 12px;
  }
}
@media (max-width: 575px) {
  .org-container {
    padding: 14px 8px 32px;
  }
  .org-header {
    margin-bottom: 24px;
  }
  .org-header h2 {
    font-size: 1.05rem;
    gap: 6px;
  }
  .org-header p {
    font-size: 0.78rem;
  }
  .org-chart-scroll {
    padding: 14px 0 40px;
  }
  .tree {
    padding: 12px;
  }
  .tree li {
    padding: 16px 6px 0 6px;
  }
  .manager-level {
    gap: 12px;
    padding-top: 16px;
  }
  .org-level-label,
  .tree-badge {
    font-size: 0.68rem;
    padding: 6px 12px;
  }
  .tree-badge-company {
    font-size: 0.75rem;
    padding: 7px 16px;
  }
  .org-card,
  .tree .org-card {
    min-width: 140px;
    padding: 9px 10px;
    gap: 8px;
  }
  .org-icon {
    width: 26px;
    height: 26px;
    font-size: 0.78rem;
    border-radius: 5px;
  }
  .org-card h4 {
    font-size: 0.74rem;
  }
  .org-card span {
    font-size: 0.66rem;
  }
}
@media (max-width: 400px) {
  .org-container {
    padding: 12px 6px 28px;
  }
  .org-header h2 {
    font-size: 0.95rem;
  }
  .tree li {
    padding: 14px 4px 0 4px;
  }
  .manager-level {
    gap: 10px;
  }
  .org-card,
  .tree .org-card {
    min-width: 128px;
    padding: 8px 8px;
  }
  .org-card h4 {
    font-size: 0.68rem;
  }
  .org-card span {
    font-size: 0.62rem;
  }
  .org-level-label,
  .tree-badge {
    font-size: 0.62rem;
    padding: 5px 10px;
  }
}
@media (max-width: 320px) {
  .org-container {
    padding: 10px 4px 24px;
  }
  .org-header h2 {
    font-size: 0.85rem;
  }
  .org-card,
  .tree .org-card {
    min-width: 118px;
    padding: 7px 7px;
  }
  .org-icon {
    width: 22px;
    height: 22px;
    font-size: 0.68rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/hr_app/OrganizationStructure/OrganizationStructure.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4CAA4C;EAC5C;;wBAEsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,4EAA4E;AAC5E;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,8BAA8B;EAC9B,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,cAAc;IACd,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;EACA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;EACX;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".org-container {\n  padding: 24px 32px 60px;\n  background: #f1f5f9;\n  min-height: 100vh;\n  margin-left: 250px;\n  width: calc(100% - 250px);\n  box-sizing: border-box;\n}\n.org-header {\n  text-align: center;\n  margin-bottom: 48px;\n}\n.org-header h2 {\n  font-size: 1.7rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  text-transform: uppercase;\n}\n.org-header p {\n  color: #64748b;\n  margin-top: 6px;\n  font-size: 0.9rem;\n}\n.org-status {\n  text-align: center;\n  color: #64748b;\n  padding: 40px 0;\n}\n.org-error {\n  color: #dc2626;\n}\n.org-chart-scroll {\n  width: 100%;\n  overflow-x: auto;\n  padding: 20px 0 60px;\n  -webkit-overflow-scrolling: touch;\n}\n.org-chart {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.org-level-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  background: #334155;\n  border-radius: 6px;\n  padding: 8px 20px;\n  margin-bottom: 4px;\n  position: relative;\n  white-space: nowrap;\n  box-shadow: 3px 3px 0 rgba(15, 23, 42, 0.15);\n}\n.org-chart > div:nth-child(4n + 2) .org-level-label {\n  background: #2f8f7d;\n}\n.org-level-count {\n  font-weight: 500;\n  color: #cbd5e1;\n}\n.org-level-label::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -20px;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 20px;\n  background: #94a3b8;\n}\n.manager-level {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 32px;\n  padding-top: 24px;\n  margin-bottom: 8px;\n  position: relative;\n  max-width: 100%;\n}\n.manager-level::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #94a3b8;\n}\n\n.manager-level:has(> :only-child)::before {\n  display: none;\n}\n\n.org-card {\n  position: relative;\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  padding: 14px 18px;\n  min-width: 190px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  box-shadow: 3px 3px 0 rgba(15, 23, 42, 0.12);\n  transition:\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n}\n\n.org-card:hover {\n  box-shadow: 4px 4px 0 rgba(15, 23, 42, 0.18);\n  transform: translate(-1px, -1px);\n}\n\n.org-card::before {\n  content: \"\";\n  position: absolute;\n  top: -24px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 24px;\n  background: #94a3b8;\n}\n\n.org-card h4 {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #1e293b;\n  text-transform: uppercase;\n}\n\n.org-card span {\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.org-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 6px;\n  background: #334155;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.95rem;\n  flex-shrink: 0;\n}\n\n.ceo-card {\n  background: #1e293b;\n  border-color: #1e293b;\n}\n\n.ceo-card h4,\n.ceo-card span {\n  color: #fff;\n}\n\n.ceo-card .org-icon {\n  background: #2f8f7d;\n  color: #fff;\n}\n\n.manager-card .org-icon {\n  background: #334155;\n  color: #fff;\n}\n\n.vertical-line {\n  width: 2px;\n  height: 28px;\n  background: #94a3b8;\n  margin: 0 auto;\n}\n\n.vertical-line.small {\n  height: 18px;\n}\n\n/* Classic pure-CSS org-chart tree: fanning connector lines between levels */\n.tree,\n.tree ul,\n.tree li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n\n.tree {\n  display: flex;\n  justify-content: center;\n  min-width: max-content;\n  padding: 20px;\n}\n\n.tree li {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 14px 0 14px;\n}\n\n.tree li::before,\n.tree li::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 50%;\n  border-top: 2px solid #94a3b8;\n  width: 50%;\n  height: 24px;\n}\n.tree li::after {\n  right: auto;\n  left: 50%;\n  border-left: 2px solid #94a3b8;\n}\n\n.tree li:only-child::after,\n.tree li:only-child::before {\n  display: none;\n}\n.tree li:only-child {\n  padding-top: 0;\n}\n\n.tree li:first-child::before,\n.tree li:last-child::after {\n  border: 0 none;\n}\n.tree li:last-child::before {\n  border-right: 2px solid #94a3b8;\n  border-radius: 0 6px 0 0;\n}\n.tree li:first-child::after {\n  border-radius: 6px 0 0 0;\n}\n\n.tree ul {\n  display: flex;\n  justify-content: center;\n  padding-top: 24px;\n  position: relative;\n}\n.tree ul::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 50%;\n  border-left: 2px solid #94a3b8;\n  width: 0;\n  height: 24px;\n}\n\n.tree-badge {\n  display: inline-block;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  border-radius: 6px;\n  padding: 8px 18px;\n  white-space: nowrap;\n  box-shadow: 3px 3px 0 rgba(15, 23, 42, 0.15);\n}\n.tree-badge-dept {\n  background: #88B6F2;\n}\n.tree-badge-role {\n  background: #334155;\n}\n\n.tree .org-card {\n  min-width: 180px;\n}\n.tree-badge-company {\n  background: #0f172a;\n  font-size: 0.9rem;\n  padding: 10px 26px;\n}\n@media (min-width: 1600px) {\n  .org-container {\n    padding: 32px 48px 72px;\n  }\n  .tree .org-card,\n  .org-card {\n    min-width: 210px;\n  }\n}\n@media (max-width: 1399px) {\n  .org-container {\n    padding: 22px 24px 50px;\n  }\n}\n\n/* Tablet landscape — sidebar usually still visible but narrower */\n@media (max-width: 1199px) {\n  .org-container {\n    margin-left: 220px;\n    width: calc(100% - 220px);\n    padding: 20px 20px 44px;\n  }\n  .org-header h2 {\n    font-size: 1.5rem;\n  }\n  .tree .org-card,\n  .org-card {\n    min-width: 170px;\n    padding: 12px 14px;\n  }\n}\n@media (max-width: 991px) {\n  .org-container {\n    margin-left: 0;\n    width: 100%;\n    padding: 18px 16px 40px;\n  }\n  .org-header {\n    margin-bottom: 32px;\n  }\n  .org-header h2 {\n    font-size: 1.35rem;\n    gap: 8px;\n  }\n  .org-header p {\n    font-size: 0.85rem;\n  }\n  .manager-level {\n    gap: 20px;\n  }\n  .tree li {\n    padding: 20px 10px 0 10px;\n  }\n  .org-card,\n  .tree .org-card {\n    min-width: 160px;\n    padding: 12px 14px;\n    gap: 10px;\n  }\n  .org-icon {\n    width: 30px;\n    height: 30px;\n    font-size: 0.85rem;\n  }\n  .org-card h4 {\n    font-size: 0.82rem;\n  }\n  .org-card span {\n    font-size: 0.72rem;\n  }\n}\n@media (max-width: 767px) {\n  .org-container {\n    padding: 16px 12px 36px;\n  }\n  .org-header h2 {\n    font-size: 1.2rem;\n    flex-wrap: wrap;\n  }\n  .org-level-label,\n  .tree-badge {\n    font-size: 0.72rem;\n    padding: 7px 14px;\n  }\n  .tree-badge-company {\n    font-size: 0.8rem;\n    padding: 8px 18px;\n  }\n  .tree li {\n    padding: 18px 8px 0 8px;\n  }\n  .manager-level {\n    gap: 16px;\n    padding-top: 18px;\n  }\n  .org-card,\n  .tree .org-card {\n    min-width: 150px;\n    padding: 10px 12px;\n  }\n}\n@media (max-width: 575px) {\n  .org-container {\n    padding: 14px 8px 32px;\n  }\n  .org-header {\n    margin-bottom: 24px;\n  }\n  .org-header h2 {\n    font-size: 1.05rem;\n    gap: 6px;\n  }\n  .org-header p {\n    font-size: 0.78rem;\n  }\n  .org-chart-scroll {\n    padding: 14px 0 40px;\n  }\n  .tree {\n    padding: 12px;\n  }\n  .tree li {\n    padding: 16px 6px 0 6px;\n  }\n  .manager-level {\n    gap: 12px;\n    padding-top: 16px;\n  }\n  .org-level-label,\n  .tree-badge {\n    font-size: 0.68rem;\n    padding: 6px 12px;\n  }\n  .tree-badge-company {\n    font-size: 0.75rem;\n    padding: 7px 16px;\n  }\n  .org-card,\n  .tree .org-card {\n    min-width: 140px;\n    padding: 9px 10px;\n    gap: 8px;\n  }\n  .org-icon {\n    width: 26px;\n    height: 26px;\n    font-size: 0.78rem;\n    border-radius: 5px;\n  }\n  .org-card h4 {\n    font-size: 0.74rem;\n  }\n  .org-card span {\n    font-size: 0.66rem;\n  }\n}\n@media (max-width: 400px) {\n  .org-container {\n    padding: 12px 6px 28px;\n  }\n  .org-header h2 {\n    font-size: 0.95rem;\n  }\n  .tree li {\n    padding: 14px 4px 0 4px;\n  }\n  .manager-level {\n    gap: 10px;\n  }\n  .org-card,\n  .tree .org-card {\n    min-width: 128px;\n    padding: 8px 8px;\n  }\n  .org-card h4 {\n    font-size: 0.68rem;\n  }\n  .org-card span {\n    font-size: 0.62rem;\n  }\n  .org-level-label,\n  .tree-badge {\n    font-size: 0.62rem;\n    padding: 5px 10px;\n  }\n}\n@media (max-width: 320px) {\n  .org-container {\n    padding: 10px 4px 24px;\n  }\n  .org-header h2 {\n    font-size: 0.85rem;\n  }\n  .org-card,\n  .tree .org-card {\n    min-width: 118px;\n    padding: 7px 7px;\n  }\n  .org-icon {\n    width: 22px;\n    height: 22px;\n    font-size: 0.68rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
